import { useIntl } from 'react-intl';
import { useMutation } from '@tanstack/react-query';
import { notification } from 'antd';

import { useConfigurationStore } from '@store/use-configuration-store';
import { useUserStore } from '@store/use-user-store';

import type { ApiError } from '../types';
import { apis } from './api/Api';

interface LoginParams {
  username: string;
  password: string;
}

const ACCESS_DENIED = 'ACCESS_DENIED';

export const useLogin = () => {
  const intl = useIntl();
  const { loginSuccess, storeTokens, logout } = useUserStore();
  const { friendly_url, module } = useConfigurationStore();

  return useMutation({
    mutationFn: async ({ username, password }: LoginParams) => {
      const { data: tokens } = await apis.login({ email: username, password });
      storeTokens(tokens);
      const { data } = await apis.checkAccessible(friendly_url, module);
      if (!data.accessible) throw new Error(ACCESS_DENIED);
      return tokens;
    },
    onSuccess: (tokens, { username, password }) => {
      loginSuccess({ username, password, ...tokens });
    },
    onError: (err: Error & ApiError) => {
      logout();
      notification.error({
        title:
          err.message === ACCESS_DENIED
            ? intl.formatMessage({ id: ACCESS_DENIED })
            : (err.response?.data?.errorMessage ?? 'Login failed'),
        placement: 'topRight'
      });
    }
  });
};
